import React, { useEffect } from 'react';
import { Box } from 'rebass/styled-components';

export const HubspotEmbed = () => {
  useEffect(() => {
    const script = document.createElement('script');
    const body = document.getElementsByTagName('body')[0];

    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    body.appendChild(script);

    return () => {
      body.removeChild(script);
    };
  }, []);

  return <Box className="meetings-iframe-container" data-src="https://meetings.hubspot.com/mitch278?embed=true" />;
};
